import React, { useRef } from 'react';
import { CAPTURE, dataHooks } from './FileUpload.constants';
import { FileUploadProps } from './FileUpload.types';

const FileUpload = ({
  dataHook,
  className,
  children,
  multiple = false,
  accept = '',
  capture = CAPTURE.user,
  name,
  onChange = () => {},
}: FileUploadProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const openFileUploadDialog = (event: React.MouseEvent) => {
    inputRef.current?.click();
    event.preventDefault();
  };

  return (
    <label className={className} data-hook={dataHook}>
      {children({
        openFileUploadDialog,
      })}

      <input
        type="file"
        data-hook={dataHooks.input}
        style={{ display: 'none' }}
        ref={inputRef}
        multiple={multiple}
        accept={accept}
        capture={capture === 'none' ? undefined : capture}
        name={name}
        onChange={e => {
          onChange(e.target.files);
          // reset the input value to allow re-uploading the same file
          e.target.value = '';
        }}
      />
    </label>
  );
};

FileUpload.displayName = 'FileUpload';

export default FileUpload;
